import { useCallback } from 'react';
import axiosInstance from '../api/axios';
import { API_ENDPOINTS } from '../api/endpoints';
import { Holiday, CreateHolidayParams, CheckTokensResult } from '../api/holidayTypes';

/** Holiday operations — wraps the /holidays endpoints (see plan §2.6). */
const BASE = API_ENDPOINTS.HOLIDAYS;

export const useHolidays = () => {
  const listHolidays = useCallback(async (queueId?: string): Promise<Holiday[]> => {
    const res = await axiosInstance.get(`${BASE}${queueId ? `?queue_id=${queueId}` : ''}`);
    return res.data?.data?.holidays ?? [];
  }, []);

  const checkTokens = useCallback(async (payload: CreateHolidayParams): Promise<CheckTokensResult> => {
    const res = await axiosInstance.post(`${BASE}/check-tokens`, payload);
    return res.data.data;
  }, []);

  const createHoliday = useCallback(async (payload: CreateHolidayParams): Promise<{ total_cancelled_tokens: number }> => {
    const res = await axiosInstance.post(BASE, payload);
    return { total_cancelled_tokens: res.data?.data?.total_cancelled_tokens ?? 0 };
  }, []);

  const deleteHoliday = useCallback(async (id: string): Promise<void> => {
    await axiosInstance.delete(`${BASE}/${id}`);
  }, []);

  return { listHolidays, checkTokens, createHoliday, deleteHoliday };
};
